import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import { SavedSecretField } from './SavedSecretField';

export const KronosAuthCard = ({ useJobConfig }) => {
  const [kronos, setKronos] = useJobConfig(['kronos']);
  const auth = kronos || {};
  const mode = auth.type === '1password_item' ? 'onepassword' : 'direct';

  const switchMode = (newMode) => {
    if (newMode === 'onepassword') {
      setKronos({
        type: '1password_item',
        '1password_item_path': ''
      });
    } else {
      setKronos({
        companyName: '',
        username: '',
        apiKey: '',
        password: '',
        baseUrl: 'https://secure.saashr.com'
      });
    }
  };

  const setAuthField = (field) => (value) =>
    setKronos({ ...auth, [field]: value });

  return (
    <Card>
      <CardHeader
        subheader="UKG credentials the job uses to read or write files"
        title="Kronos"
      />
      <CardContent>
        <FormControl sx={{ marginBottom: '16px' }}>
          <RadioGroup
            onChange={(e) => switchMode(e.target.value)}
            row
            value={mode}
          >
            <FormControlLabel
              control={<Radio />}
              label="Reference a 1Password item"
              value="onepassword"
            />
            <FormControlLabel
              control={<Radio />}
              label="Enter credentials directly"
              value="direct"
            />
          </RadioGroup>
        </FormControl>
        {mode === 'onepassword' ? (
          <TextField
            fullWidth
            helperText="e.g. Client credentials/UKG - EnjoyWurkAdmin - apiuser"
            label="1Password item path"
            onChange={(e) =>
              setAuthField('1password_item_path')(e.target.value)
            }
            required
            value={auth['1password_item_path'] || ''}
            variant="standard"
          />
        ) : (
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Kronos company name"
                onChange={(e) => setAuthField('companyName')(e.target.value)}
                required
                value={auth.companyName || ''}
                variant="standard"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Kronos username"
                onChange={(e) => setAuthField('username')(e.target.value)}
                required
                value={auth.username || ''}
                variant="standard"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <SavedSecretField
                label="Kronos API key"
                onChange={setAuthField('apiKey')}
                secret={auth.apiKey ?? ''}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <SavedSecretField
                label="Kronos password"
                onChange={setAuthField('password')}
                secret={auth.password ?? ''}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Kronos base URL"
                onChange={(e) => setAuthField('baseUrl')(e.target.value)}
                required
                value={auth.baseUrl || ''}
                variant="standard"
              />
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};
